import { ThermometerAutoIcon } from './ThermometerAutoIcon';

/**
 * author: Hans Böhm
 * id EBC857F8-EDAD-46AF-9F34-0DCB03E27998
 * name thermometer-auto
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-auto.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const TemperatureAutoIcon = ThermometerAutoIcon;
export default TemperatureAutoIcon